import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  state: {
    token: '',
    user:{},
    company: {}, 
    menuList: [],//菜单结构
    userList: [], //系统中所有用户
  },
  getters: {
  },
  mutations: {
    setToken(state, e) {
      state.token = e
    },
    setCompanyData(state, e) {
      state.company = e;
    },
    setUserData(state, e) {
      state.user = e;
    },
    setMenuList(state, e) {
      state.menuList = e;
    },
    setUserList(state, e) {
      state.userList = e;
    },
    clearStore(state) {
      state.user = {};
      state.token = '';
      state.menuList = [];
      state.userList = [];
      state.company = {};
    }
  },
  actions: {
    setToken(storage, e) {
      storage.commit('setToken', e);
    },
    setCompanyData(storage, e) {
      storage.commit('setCompanyData', e);
    },
    setUserData(storage, e) {
      storage.commit('setUserData', e);
    },
    setMenuList(storage, e) {
      storage.commit('setMenuList', e);
    },
    setUserList(storage, e) {
      storage.commit('setUserList', e);
    },
    clearStore(storage) {
      storage.commit('clearStore');
    }
  },
  modules: {
  },
  //持久化数据
  plugins: [
    createPersistedState({
      key: 'vuex',
      //可选，sessionStorage/indexDB/localStorage
      storage: window.localStorage
    })
  ]
})
